import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import "./EventEdit.css";
import NotesPreview from "./NotesPreview";

import AlertModal from "./AlertModal";
import MultiSelectModal from "./MultiSelectModal";
import HTMLReader from "./HTMLReader";
import PlaceMenu from "../../CommonWeb/PlaceMenu";
import { urlSchemeToFunctions } from "../../CommonWeb/Common";

import Common from "../../Common/Common";
import Place from "../../Models/Place";
import Appointment from "../../Models/Event";
import Schedule from "../../Models/Schedule";
import store from "../../store/store";
import { placeRowFor } from "../../Common/placeRow";
import { DateTime, Settings } from "luxon";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommentsSection from "../CommentsSection";

// Configure the time zone
Settings.defaultZoneName = "UTC";

class EventEdit extends Component {
  constructor(props) {
    super(props);
    const event = this.props.event;
    const mode = this.props.mode;
    const place = this.props.place;
    const dateTime = this.props.dateTime;
    const where = this.props.where;

    //console.log("event", event);
    //console.log("mode", mode);
    //console.log("place", place);
    let initialSubject = "";
    let initialStart = window.guide_obj.schedule.getFirsEventStartDate(this.props.schedule_name); //this.props.initDate;

    console.log("initialStart", initialStart.toJSDate());
    //initialStart.setMinutes(0);
    initialStart = initialStart.set({ minute: 0 });
    let initialEnd = initialStart.plus({ hours: 1 });
    //initialEnd.setTime(initialEnd.getTime() + 1 * 60 * 60 * 1000);
    let initialItinerary = this.props.schedule_name;
    this._afterEvent = where === "after" && mode === "ADD" && event != null ? event : null;
    if (where == "after" && event != null) {
      initialStart = DateTime.fromISO(event.End, { zone: "utc" });
      initialEnd = DateTime.fromISO(event.End, { zone: "utc" }).plus({ minutes: 60 });
    } else if (where == "before" && event != null) {
      initialStart = DateTime.fromISO(event.Start, { zone: "utc" }).minus({ minutes: 60 });
      initialEnd = DateTime.fromISO(event.Start, { zone: "utc" });
    } else if (where === "end" && mode == "ADD") {
      let start_end = window.guide_obj.schedule.getStartEndDate(this.props.schedule_name);
      initialStart = start_end.endDate;
      console.log("initialStart", initialStart.toJSDate());
      initialStart = initialStart.set({ minute: 0 });
      initialEnd = initialStart.plus({ hours: 1 });
    }
    if (where == "" && mode == "ADD" && dateTime != null) {
      initialStart = dateTime;
      initialEnd = dateTime;
    }
    let initialNotes = "";
    let initialPlaces = [];
    if (place != null) {
      initialPlaces = [{ Name: place.Name, ID: place.ID }];
      initialSubject = place.Name;
    }
    if (mode != "ADD" && event != null) {
      initialSubject = event.Subject;

      initialStart = DateTime.fromISO(event.Start, { zone: "utc" });
      if (!initialStart.isValid) initialStart = DateTime.now().setZone("utc");
      initialEnd = DateTime.fromISO(event.End, { zone: "utc" });
      if (!initialEnd.isValid) initialEnd = initialStart.plus({ hours: 1 });
      initialNotes = event.Body ?? "";
      initialItinerary = typeof event.Itinerary == "undefined" ? "Main" : event.Itinerary;
      //let _places = Places.getPlaceNames(event.Places);

      const _places = event.get_places(window.guide_obj.places);
      for (let i = 0; i < _places.length; i++) {
        if (typeof _places[i].Name !== "undefined") initialPlaces.push({ Name: _places[i].Name, ID: _places[i].ID });
      }
    }
    const Itineraries = window.guide_obj.schedule.geScheduleNames();
    //Itineraries.splice(0, 0, { label: "NEW", value: "NEW" });
    //console.log(initialStart, initialEnd);
    this.state = {
      Subject: initialSubject,
      Start: initialStart,
      End: initialEnd,
      Notes: initialNotes,
      // tempNotes: initialNotes,
      notesUpdated: initialNotes,
      Places: initialPlaces,

      dateStart: initialStart,
      modeStart: "date",
      showStart: false,

      dateEnd: initialEnd,
      modeEnd: "date",
      showEnd: false,
      Itineraries: Itineraries,
      Itinerary: initialItinerary,
      visiblePrompt: false,
      newScheduleName: "",
      scheduleLabel: "Choose different schedule...",

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,

      HTMLReaderShow: false,
      HTMLReaderTitle: "",
      HTMLReaderHtml: "",
    };
    this.handleChangeSubject = this.handleChangeSubject.bind(this);
    //this.handleChangeStart = this.handleChangeStart.bind(this);
    //this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.handleChangeNotes = this.handleChangeNotes.bind(this);
    this.handleChangePlaces = this.handleChangePlaces.bind(this);
  }

  handleShowPlaceDetails = (placeId) => {
    let htmlString = PlaceMenu.handleShowPlaceAttributes(placeId, null);
    htmlString = urlSchemeToFunctions(htmlString);
    this.setState({
      HTMLReaderTitle: "Place Details",
      HTMLReaderHtml: htmlString,
      HTMLReaderShow: true,
    });
  };

  MyAlert = (message) => {
    this.setState({
      AlertModalTitle: "Message",
      AlertModalMessage: message,
      AlertModalButtons: [{ Title: "OK", Method: null }],
      AlertModalShow: true,
    });
  };

  handleChangeSubject = (newText) => {
    this.setState({ ...this.state, Subject: newText });
  };
  NotesUpdated = (newText) => {
    console.log("NotesUpdated", newText);
    this.setState({ ...this.state, notesUpdated: newText });
  };
  handleChangeNotes = (newText) => {
    this.setState({ ...this.state, Notes: newText });
  };
  handleChangePlaces = (newText) => {
    this.setState({ ...this.state, Places: newText });
  };
  editInfo = () => {
    this.props.navigation.navigate("HTMLEditor", { html: this.state.Notes, callback: this.editInfoCallback });
  };
  editInfoCallback = (html) => {
    this.setState({ Notes: html });
  };
  AddEvent = () => {
    //console.log("AddEvent");
    //this.props.onAddEvent("AddEvent");

    if (this.state.dateStart > this.state.dateEnd) {
      this.MyAlert("End date/time must be greater than Start date/time");
      return;
    }
    if (this.state.Itinerary === "") {
      this.MyAlert("Must specify Schedule Name");
      return;
    }
    if (this.state.Subject === "") {
      this.MyAlert("Must specify Subject");
      return;
    }
    if (this.state.dateStart > this.state.dateEnd) {
      //console.log("this.state.dateStart, this.state.dateEnd", this.state.dateStart, this.state.dateEnd);
      this.MyAlert("End time must be greater than start time Latitude");
      return;
    }
    const mode = this.props.mode;
    const old_event = this.props.event;
    const callback = this.props.callback;
    let new_event = new Appointment();
    let _placeIDs = "";
    if (mode == "ADD") {
      new_event.Subject = this.state.Subject;
      new_event.Start = this.state.dateStart.toISO({ zone: "utc" }); //this.state.dateStart;
      new_event.End = this.state.dateEnd.toISO({ zone: "utc" }); //this.state.dateEnd;
      new_event.Body = this.state.notesUpdated;
      new_event.Itinerary = this.state.Itinerary;
      this.state.Places.forEach((place) => {
        _placeIDs += _placeIDs != "" ? "," + place.ID : place.ID;
      });
      new_event.Places = _placeIDs;
      //console.log("new_event", new_event);
      window.guide_obj.schedule.addEvent(new_event);
    } else {
      old_event.Subject = this.state.Subject;
      old_event.Start = this.state.dateStart.toISO({ zone: "utc" }); //this.state.dateStart;
      old_event.End = this.state.dateEnd.toISO({ zone: "utc" }); //this.state.dateEnd;
      old_event.Body = this.state.notesUpdated;
      old_event.Itinerary = this.state.Itinerary;
      this.state.Places.forEach((place) => {
        _placeIDs += _placeIDs != "" ? "," + place.ID : place.ID;
      });
      //console.log("old_event", old_event);
      old_event.Places = _placeIDs;
      //console.log("old_event", old_event);
      window.guide_obj.schedule.modifyEvent(old_event);
    }
    if (callback != null) callback();
    this.props.onHide();
  };

  onChangeStart = (event) => {
    const dateStart = Common.LuxonDateFromJSDate(event);
    let dateEnd = this.state.dateEnd;
    if (dateEnd.startOf("day") < dateStart.startOf("day")) {
      dateEnd = dateEnd.set({ year: dateStart.year, month: dateStart.month, day: dateStart.day });
    }
    if (dateEnd.hour * 60 + dateEnd.minute < dateStart.hour * 60 + dateStart.minute) {
      dateEnd = dateEnd.set({ hour: dateStart.hour, minute: dateStart.minute, second: dateStart.second });
    }
    this.setState({ ...this.state, dateStart: dateStart, dateEnd: dateEnd });
  };

  onChangeEnd = (event) => {
    const dateEnd = Common.LuxonDateFromJSDate(event);
    let dateStart = this.state.dateStart;
    if (dateStart.startOf("day") > dateEnd.startOf("day")) {
      dateStart = dateStart.set({ year: dateEnd.year, month: dateEnd.month, day: dateEnd.day });
    }
    if (dateStart.hour * 60 + dateStart.minute > dateEnd.hour * 60 + dateEnd.minute) {
      dateStart = dateStart.set({ hour: dateEnd.hour, minute: dateEnd.minute, second: dateEnd.second });
    }
    this.setState({ ...this.state, dateStart: dateStart, dateEnd: dateEnd });
  };

  showModeStart = (currentMode) => {
    this.setState({ ...this.state, showStart: true, modeStart: currentMode });
  };

  showDatepickerStart = () => {
    console.log(this.state.modeStart, this.state.showStart);
    this.showModeStart("date");
  };

  showTimepickerStart = () => {
    console.log(this.state.modeStart, this.state.showStart);
    this.showModeStart("time");
  };

  showModeEnd = (currentMode) => {
    this.setState({ ...this.state, showEnd: true, modeEnd: currentMode });
  };

  showDatepickerEnd = () => {
    // setTimeout(() => {
    //   this.showModeEnd("time");
    // }, 500);
    this.showModeEnd("date");
  };

  showTimepickerEnd = () => {
    this.showModeEnd("time");
  };

  selectGroups = () => {
    this.MultiSelect(
      window.guide_obj.getGroupsToDisplay(null),
      [],
      "multi",
      this.selectGroupsCallBack,
      "Select Groups"
    );
  };

  selectGroupsCallBack = (Groups) => {
    let groupIDs = [];
    Groups.forEach((group) => {
      groupIDs.push(group.id);
    });
    let group_places = window.guide_obj.getGroupAndCategoryPlaces([], groupIDs, []);
    let _places = [];
    group_places.forEach((place) => {
      _places.push({
        Name: place.Name,
        ID: place.ID,
      });
    });
    let unique_array = this.state.Places.concat(_places);
    unique_array = Array.from(new Set(unique_array));
    this.setState({ ...this.state, Places: unique_array });
  };

  // The place linked to whichever scheduled event sits immediately before
  // this one's Start, in the same itinerary — used by selectPlaces to sort
  // candidates by real travel distance from where the traveler already is
  // at this point in the trip, instead of a flat alphabetical list. Editing
  // an existing event (mode !== "ADD") excludes that event itself, so it's
  // never its own anchor. Returns null when nothing qualifies (e.g. the
  // very first event of an empty schedule) — callers fall back to
  // alphabetical order in that case, same as before this feature existed.
  _getAnchorPlaceForPlaceList = () => {
    const itinerary = this.state.Itinerary;
    const startTime = this.state.Start;
    const events = window.guide_obj.schedule.events.filter((e) => {
      const it = typeof e.Itinerary === "undefined" ? "Main" : e.Itinerary;
      if (it !== itinerary) return false;
      if (this.props.mode !== "ADD" && this.props.event && e.ID === this.props.event.ID) return false;
      return true;
    });
    const before = events
      .filter((e) => DateTime.fromISO(e.Start, { zone: "utc" }) < startTime)
      .sort((a, b) => DateTime.fromISO(b.Start, { zone: "utc" }) - DateTime.fromISO(a.Start, { zone: "utc" }));
    for (const e of before) {
      const placeId = (e.Places || "").split(",").map((x) => x.trim()).filter(Boolean)[0];
      if (!placeId) continue;
      const p = window.guide_obj.places.getPlace(placeId);
      if (p) return p;
    }
    return null;
  };

  // Builds the "Select Places" list for this event: ordered by real travel
  // time from the previous scheduled place (closest first) instead of a
  // flat alphabetical list, with each row labeled with that distance, an
  // "Already in schedule" flag (same referencedIds check as
  // Schedule.findReplaceCandidates/findFillCandidates), and this event's
  // own opening-hours status at its own Start time (reusing
  // Place.isOpenAt/openingStatusAt/minutesUntilCloseAt — no new Place.js
  // logic needed, same statics the schedule's warning badges already use).
  // Closed places are labeled, never hidden or excluded — matches how every
  // other part of the app treats a closed place (a warning, not a block).
  // Found/added 2026-09-30, user-requested.
  _buildPlaceListForSelect = () => {
    const anchorPlace = this._getAnchorPlaceForPlaceList();
    const startTime = this.state.Start;
    const rounding_to = this.props.event_time_rounding ?? 15;

    // "In schedule" = in THIS event's schedule, unless the guide's schedules
    // share places — see Schedule.eventsCountedAsUsed. 2026-10-16.
    const referencedIds = new Set();
    Schedule.eventsCountedAsUsed(this.state.Itinerary).forEach((e) => {
      (e.Places || "").split(",").map((id) => id.trim()).filter(Boolean).forEach((id) => referencedIds.add(id));
    });

    // badges (icon + short text) drive the picker row's own compact display
    // (MultiSelectModal.js) — label itself stays the PLAIN place name, never
    // decorated, so it can never be the thing that overflows/truncates on a
    // small screen the way a long "Name · 8 min away · Open until 6pm"
    // string did. pillText is the one place that still wants the full
    // decorated string, for EventEdit's own "selected places" chip row
    // (secondary UI with room for it) — built once here so both consumers
    // share the same underlying data instead of recomputing it twice.
    // Icons reuse PlaceCard.js's existing convention (calendar = Scheduled,
    // clock = hours-related) rather than inventing new ones. Found
    // 2026-09-30, user-requested (small-screen truncation + PlaceCard icon
    // parity).
    const base = window.guide_obj.places.getPlacesToDisplay(null);
    const withMeta = base.map((item) => {
      const place = window.guide_obj.places.getPlace(item.value);
      const travelMinutes = anchorPlace && place ? Common.estimateTravelTimeMinutes(anchorPlace, place, rounding_to) : null;
      let hoursText = "";
      let hoursTint = "";
      if (place && startTime && startTime.isValid) {
        const open = Place.isOpenAt(place, startTime);
        if (open === false) {
          const { closedAllDay, minutesUntilOpen } = Place.openingStatusAt(place, startTime);
          hoursText = closedAllDay
            ? "Closed all day"
            : minutesUntilOpen != null
            ? `Opens ${Common.formatTimeBrief(startTime.plus({ minutes: minutesUntilOpen }).toISO())}`
            : "Closed";
          hoursTint = "tint-amber";
        } else if (open === true) {
          const minutesUntilClose = Place.minutesUntilCloseAt(place, startTime);
          if (minutesUntilClose != null) {
            hoursText = `Until ${Common.formatTimeBrief(startTime.plus({ minutes: minutesUntilClose }).toISO())}`;
          }
        }
      }
      const isScheduled = referencedIds.has(String(item.value));
      const badges = [
        travelMinutes != null ? { icon: solid("route"), text: Common.formatTravelDuration(travelMinutes) } : null,
        hoursText ? { icon: solid("clock"), text: hoursText, tint: hoursTint } : null,
        isScheduled ? { icon: solid("calendar"), text: "In schedule", tint: "tint-blue" } : null,
      ].filter(Boolean);
      const pillText = badges.length > 0 ? `${item.label} · ${badges.map((b) => b.text).join(" · ")}` : item.label;
      // Photo, category · visit length, a line of notes (2026-10-17).
      const placeRow = placeRowFor(place, { categories: window.guide_obj.categories, user_info: store.getState().user_info });
      return { ...item, badges, pillText, travelMinutes, placeRow };
    });

    if (!anchorPlace) return withMeta;
    // Places with no resolvable distance (no coords, or missing from the
    // model somehow) sort after every real distance, keeping the list
    // stable rather than treating "unknown" as "closest".
    return withMeta.sort((a, b) => {
      const av = a.travelMinutes;
      const bv = b.travelMinutes;
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      return av - bv;
    });
  };

  selectPlaces = () => {
    //this.setState({ ...this.state, tempNotes: this.notesUpdated });
    let selectedPlaces = [];
    this.state.Places.forEach((place) =>
      selectedPlaces.push({
        label: place.Name,
        name: place.Name,
        value: place.ID,
      })
    );
    //console.log("selectedPlaces", selectedPlaces);
    this.MultiSelect(
      this._buildPlaceListForSelect(),
      selectedPlaces,
      "multi",
      this.selectPlacesCallBack,
      "Select Places"
    );
  };

  // "Add event after" starts exactly where the previous event ends, before
  // a place is chosen. When the first place is picked and the times haven't
  // been changed, the start moves by the travel time from the previous
  // event's place, and the end follows the place's visit length (or keeps
  // the hour). 2026-10-17 — the travel row showed ~15 min but the event
  // started at the previous one's end.
  _startAfterTravel = (places) => {
    const after = this._afterEvent;
    if (!after || !places.length || (this.state.Places || []).length > 0) return null;
    const afterEnd = DateTime.fromISO(after.End, { zone: "utc" });
    if (+this.state.dateStart !== +afterEnd) return null;
    const placesModel = window.guide_obj.places;
    const fromId = String(after.Places || "").split(",").map((x) => x.trim()).filter(Boolean)[0];
    const from = fromId ? placesModel.getPlace(fromId) : null;
    const to = placesModel.getPlace(places[0].ID);
    if (!from || !to) return null;
    const travel = Common.estimateTravelTimeMinutes(from, to, store.getState().user_info?.event_time_rounding ?? 15) || 0;
    const start = afterEnd.plus({ minutes: travel });
    const minutes = Number(to.Duration) > 0 ? Number(to.Duration) : this.state.dateEnd.diff(this.state.dateStart, "minutes").minutes || 60;
    return { dateStart: start, dateEnd: start.plus({ minutes }), Start: start, End: start.plus({ minutes }) };
  };

  selectPlacesCallBack = (Places) => {
    let _places = [];
    Places.forEach((place) =>
      _places.push({
        // Name stays the plain place name (used for the event's Subject,
        // which should read like "Colosseum", not "Colosseum · 8 min ·
        // In schedule") — label is always plain now (see
        // _buildPlaceListForSelect), so this no longer needs a fallback.
        // DisplayLabel carries the full decorated text (distance/hours/
        // already-scheduled) for the places-chip row below, which has room
        // for it since it's secondary UI, not the event's own title. Falls
        // back to Name when absent (e.g. places added via "Select from
        // Groups", which was never decorated). Found 2026-09-30.
        Name: place.label,
        DisplayLabel: place.pillText || place.label,
        ID: place.value,
      })
    );
    let title = this.state.Subject;
    if (_places.length > 0) if (title == "") title = _places[0].Name;
    const times = this._startAfterTravel(_places) || {};
    this.setState({ ...this.state, Places: _places, Subject: title, ...times });
    // setTimeout(() => {
    //   this.setState({ ...this.state, notesUpdated: this.tempNotes });
    // }, 200);
  };

  createPlace = () => {
    this.props.navigation.navigate("PlaceEdit", {
      place: null,
      mode: "ADD",
      type: "Icon",
      callback: this.createPlaceCallback,
    });
  };

  createPath = () => {
    this.props.navigation.navigate("PlaceEdit", {
      place: null,
      mode: "ADD",
      type: "PolyLine",
      callback: this.createPlaceCallback,
    });
  };

  createArea = () => {
    this.props.navigation.navigate("PlaceEdit", {
      place: null,
      mode: "ADD",
      type: "Polygon",
      callback: this.createPlaceCallback,
    });
  };

  createPlaceCallback = (place) => {
    if (place === null) return;
    let new_place = { label: place.Name, value: place.ID };
    let _places = this.state.Places;
    _places.push(new_place);
    let unique_array = Array.from(new Set(_places));
    this.selectPlacesCallBack(unique_array);
  };

  placeSelected = (label, value) => {
    let Places = this.state.Places;
    if (Places != "") Places += ",";
    Places += label;

    this.setState({ ...this.state, Places: Places });
  };

  displayPlaces = () => {
    let _places = "";
    this.state.Places.forEach((place) => {
      _places += _places != "" ? "," + place.Name : place.Name;
    });
    return _places;
  };

  newScheduleName = () => {
    this.setState({ visiblePrompt: true });
  };

  addNewScheduleName = () => {
    //console.log(this.state.newScheduleName);
    this.setState({ visiblePrompt: false, Itinerary: this.state.newScheduleName });
  };

  textChanged = (text) => {
    this.setState({ newScheduleName: text });
  };

  ScheduleSelected = (item) => {
    //console.log(item);
    this.setState({ Itinerary: item.label });
  };

  chooseSchedule = () => {
    //console.log("selectLinkType");
    this.props.navigation.navigate("MultiSelectDialog", {
      selectionList: this.props.ScheduleNames,
      selectedItems: this.props.schedule_name,
      callBack: this.chooseScheduleCallBack,
      edit_type: "Schedule",
      title: "Schedule",
      selectText: "Select Schedule",
      mode: "uni",
    });
  };

  // JSDateFromLuxonDate(date) {
  //   const JSDate = new Date(date.year, date.month - 1, date.day, date.hour, date.minute, 0);
  //   return JSDate;
  // }

  // LuxonDateFromJSDate(date) {
  //   const LuxonDate = DateTime.fromObject(
  //     {
  //       year: date.getFullYear(),
  //       month: date.getMonth() + 1,
  //       day: date.getDate(),
  //       hour: date.getHours(),
  //       minute: date.getMinutes(),
  //       second: 0,
  //     },
  //     { zone: "utc" }
  //   );
  //   return LuxonDate;
  // }

  chooseScheduleCallBack = (schedules) => {
    if (schedules.length > 0) {
      this.setState({ Itinerary: schedules[0].label });
    }
  };
  displayList(arr) {
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      if (str != "") str += ", ";
      str += arr[i];
    }
    return str;
  }

  displayValueList(arr) {
    console.log("displayValueList", arr);
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      if (str != "") str += ", ";
      str += arr[i].Name;
    }
    return str;
  }

  // handleChangetime = (event, which) => {
  //   const hour_min = event.target.value.split(":");
  //   let newDate = this.state.dateStart.set({ hour: parseInt(hour_min[0]), minutes: parseInt(hour_min[1]) });
  //   if (which === "Start") {
  //     let newDate = this.state.dateStart.set({ hour: parseInt(hour_min[0]), minutes: parseInt(hour_min[1]) });
  //     this.setState({ start_time: event.target.value, dateStart: newDate });
  //   } else {
  //     newDate = this.state.dateEnd.set({ hour: parseInt(hour_min[0]), minutes: parseInt(hour_min[1]) });
  //     this.setState({ end_time: event.target.value, dateEnd: newDate });
  //   }
  //   console.log("newDate", newDate.toString());
  // };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    console.log("MultiSelect");
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  render() {
    return (
      <div className="modal">
        <Modal
          {...this.props}
          enforceFocus={false}
          animation={false}
          dialogClassName="ee-dialog"
          aria-labelledby="ee-title"
          centered
          scrollable={false}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="ee-shell">

              {/* ── Header ── */}
              <div className="ee-header">
                <div className="ee-header-icon">
                  <FontAwesomeIcon icon={solid("calendar-days")} />
                </div>
                <h2 className="ee-title" id="ee-title">
                  {this.props.mode === "ADD" ? "Add Event" : "Edit Event"}
                </h2>
                <button className="ee-save-btn" onClick={() => this.AddEvent()}>
                  <FontAwesomeIcon icon={solid("check")} />
                  Save
                </button>
                <button className="ee-close" onClick={() => this.props.onHide()}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>

              {/* ── Body ── */}
              <div className="ee-body">

                {/* Subject */}
                <div className="ee-section">
                  <span className="ee-section-label">Subject</span>
                  <div className="ee-card">
                    <div className="ee-input-row">
                      <input
                        className="ee-input"
                        type="text"
                        placeholder="Event title"
                        value={this.state.Subject}
                        onChange={(e) => this.handleChangeSubject(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Schedule */}
                <div className="ee-section" style={{ zIndex: 99999999, position: "relative" }}>
                  <span className="ee-section-label">Schedule</span>
                  <div className="ee-card">
                    <div className="ee-date-row">
                      <span className="ee-date-label">Start</span>
                      <div className="ee-datepicker-wrapper">
                        <DatePicker showMonthDropdown showYearDropdown dropdownMode="select"
                          selected={Common.JSDateFromLuxonDate(this.state.dateStart)}
                          onChange={(date) => this.onChangeStart(date)}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={5}
                          timeCaption="time"
                          dateFormat="MMM d, yyyy  HH:mm"
                        />
                      </div>
                    </div>
                    <div className="ee-divider" />
                    <div className="ee-date-row">
                      <span className="ee-date-label">End</span>
                      <div className="ee-datepicker-wrapper">
                        <DatePicker showMonthDropdown showYearDropdown dropdownMode="select"
                          selected={Common.JSDateFromLuxonDate(this.state.dateEnd)}
                          onChange={(date) => this.onChangeEnd(date)}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={5}
                          timeCaption="time"
                          dateFormat="MMM d, yyyy  HH:mm"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Places */}
                <div className="ee-section">
                  <span className="ee-section-label">Places</span>
                  <div className="ee-card">
                    <button className="ee-selector-row" onClick={() => this.selectPlaces()}>
                      <FontAwesomeIcon icon={solid("location-dot")} className="ee-row-icon" />
                      <span className="ee-selector-label">Select Places</span>
                      <FontAwesomeIcon icon={solid("chevron-right")} className="ee-selector-chevron" />
                    </button>
                    <div className="ee-divider" />
                    <button className="ee-selector-row" onClick={() => this.selectGroups()}>
                      <FontAwesomeIcon icon={solid("layer-group")} className="ee-row-icon" />
                      <span className="ee-selector-label">Select from Groups</span>
                      <FontAwesomeIcon icon={solid("chevron-right")} className="ee-selector-chevron" />
                    </button>
                  </div>
                  {this.state.Places.length > 0 && (
                    <div className="ee-places-list">
                      {this.state.Places.map((place, i) => (
                        <span
                          key={i}
                          className="ee-place-chip"
                          onClick={() => this.handleShowPlaceDetails(place.ID)}
                          role="button"
                          tabIndex={0}
                          style={{ cursor: "pointer" }}
                        >
                          {place.DisplayLabel || place.Name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {/* Notes */}
                <div className="ee-section">
                  <span className="ee-section-label">Notes</span>
                  {/* Preview + Edit button: the editor starts only on Edit
                      (each start counts toward the TinyMCE plan). */}
                  <NotesPreview html={this.state.notesUpdated} title="Info" onChange={this.NotesUpdated} />
                </div>

                {/* Comments */}
                {this.props.mode !== "ADD" && this.props.event && this.props.event.ID ? (
                  <div className="ee-section">
                    <CommentsSection targetType="event" item={this.props.event} />
                  </div>
                ) : null}

              </div>
            </div>
          </Modal.Body>
        </Modal>

        {this.state.ShowMultiselect ? (
          <MultiSelectModal
            show={this.state.ShowMultiselect}
            onHide={() => this.setState({ ShowMultiselect: false })}
            MultiselectItems={this.state.MultiselectItems}
            MultiselectSelectedItems={this.state.MultiselectSelectedItems}
            MultiselectMode={this.state.MultiselectMode}
            MultiselectCallback={this.state.MultiselectCallback}
            MultiselectTitle={this.state.MultiselectTitle}
            MultiselectSearchText={this.state.MultiselectSearchText}
          />
        ) : null}
        {this.state.AlertModalShow ? (
          <AlertModal
            show={this.state.AlertModalShow}
            onHide={() => this.setState({ AlertModalShow: false })}
            AlertModalTitle={this.state.AlertModalTitle}
            AlertModalMessage={this.state.AlertModalMessage}
            AlertModalButtons={this.state.AlertModalButtons}
          />
        ) : null}
        {this.state.HTMLReaderShow ? (
          <HTMLReader
            show={this.state.HTMLReaderShow}
            html={this.state.HTMLReaderHtml}
            title={this.state.HTMLReaderTitle}
            compact={false}
            onHide={() => this.setState({ HTMLReaderShow: false })}
          />
        ) : null}
      </div>
    );
  }
}

export default EventEdit;
